import {Link} from "react-router-dom";

const Crumb = ({to, ...props}) =>
    <span className="rounded-md text-sm font-medium dark:text-white hover:text-green-600 dark:hover:text-green-400">
        <Link to={to} {...props}/>
    </span>

export default Crumb;